// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cwmaychzwkmeoulfjnhr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3bWF5Y2h6d2ttZW91bGZqbmhyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUxMzQ0MzQsImV4cCI6MjA1MDcxMDQzNH0.WBg4tNBdzyLTN49xf6QPCtG9dgijgPDlKc64XAUvPmM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);